<template>
    <div class="blocking-click-info">
        <div v-if="click_data_loading || !click_data">
            <div class="loader">
                <svg class="circular" viewBox="25 25 50 50">
                    <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="3" stroke-miterlimit="10"/>
                </svg>
            </div>
        </div>

        <table v-else>
            <thead></thead>
            <tbody>
                <tr><td colspan="2" style="padding-bottom: 15px; font-weight: 500;">
                    This IP address was blocked after the threat was detected from the following click:
                </td></tr>
                <tr>
                    <td>Google click ID (gclid)</td>
                    <td>{{click_data.gclid}}</td>
                </tr><tr>
                    <td>Ad group</td>
                    <td>{{click_data.ad_group}}</td>
                </tr><tr>
                    <td>Ad</td>
                    <td>{{click_data.ad}}</td>
                </tr><tr>
                    <td>Device</td>
                    <td><show-device :device="click_data.device" :show_name="true"></show-device></td>
                </tr><tr>
                    <td>OS</td>
                    <td><show-os :os="click_data.os"></show-os></td>
                </tr><tr>
                    <td>Browser</td>
                    <td>{{click_data.browser}}</td>
                </tr><tr>
                    <td>Geolocation</td>
                    <td>
                        <img v-if="click_data.country_code"
                             class="country-flag"
                             :src="'http://purecatamphetamine.github.io/country-flag-icons/3x2/'+click_data.country_code.toUpperCase()+'.svg'" alt="country flag">
                        <span v-else
                              class="empty-country-flag"></span>
                        <span style="margin-left: 5px;">{{ click_data.country_name }}</span>
                    </td>
                </tr><tr>
                    <td>Threat</td>
                    <td>
                        <inline-svg
                            v-if="'Threshold rule' === click_data.detection_reason"
                            src="/images/blocking_reason/threshold_rule.svg" aria-label="reason">
                        </inline-svg>
                        <inline-svg
                            v-else-if="'Proxy and anonymizers' === click_data.detection_reason"
                            src="/images/blocking_reason/proxy.svg" aria-label="reason">
                        </inline-svg>
                        <span style="margin-left: 5px;">{{click_data.detection_reason}}</span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
    import {setCookiesDateRange} from "../../helpers/date-converter";

    export default {
        props: ['click_id', 'initial_click_id'],
        data: function () {
            return {
                click_data: null,
                click_data_loading: false,
            }
        },
        methods:{
            loadClickData(){
                this.click_data_loading = true;
                axios.post('blocked/clickInfo', {
                    click_id: this.initial_click_id ? this.initial_click_id : this.click_id,
                })
                    .then(info => {
                        this.click_data = info.data;
                        this.click_data_loading = false;
                    })
                    .catch(err => {
                        console.log('err', err);
                        this.click_data_loading = true;
                    });
            }
        },
        mounted() {
            this.loadClickData();
        },
        watch: {
            click_id: function() {
                this.loadClickData();
            }
        }
    }
</script>
